module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58f20bb3e3aa666fb36a27ba5a0f746f.png";